<div class="container" fxLayout="row">
  <mat-card class="card-container">
    <h3>Reset Password</h3>
    <mat-card-content>
      <p style="font-weight: 500">
        Please provide a new password below.
      </p>
      <p>An email may have been sent to your account, please refer to it for further instructions.</p>
      <form [formGroup]="form" class="os-text-center">
        <div fxLayout="column">

          <mat-form-field *ngIf="!userEmail" class="os-w-100">
            <mat-placeholder>Email</mat-placeholder>
            <input matInput formControlName="userEmail" type="email" readonly>
          </mat-form-field>

          <mat-form-field *ngIf="!requestKey" class="os-w-100">
            <mat-placeholder>Reset Key</mat-placeholder>
            <input matInput formControlName="requestKey">
          </mat-form-field>

          <mat-form-field class="os-w-100">
            <mat-placeholder>New Password</mat-placeholder>
            <input matInput formControlName="newPassword" required type="password" autocomplete="new-password">
            <mat-error *ngIf="form.controls.newPassword.errors?.required">New password is required</mat-error>
            <mat-error *ngIf="form.controls.newPassword.errors?.minLength">Password must be at least 6 characters long
            </mat-error>
          </mat-form-field>

          <mat-form-field class="os-w-100">
            <mat-placeholder>Verify Password</mat-placeholder>
            <input matInput formControlName="verifyPassword" required type="password">
            <mat-error *ngIf="form.controls.verifyPassword.errors?.mismatchedPasswords">Passwords do not match
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button [disabled]="!form.valid" mat-raised-button color="primary"
        (click)="updatePassword()">Update</button>
      <button mat-button [routerLink]="['/']" mat-raised-button color="accent">Cancel</button>
    </mat-card-actions>
  </mat-card>
</div>